import { Route, Routes } from 'react-router-dom';
import { PageErrorBoundary } from './components/PageErrorBoundary';
import { HomePage } from './pages/HomePage';
import { RepoPage } from './pages/RepoPage';
import { PrintPage } from './pages/PrintPage';
import { ComparePage } from './pages/ComparePage';
import { PlanPage } from './pages/PlanPage';
import { ReportsPage } from './pages/ReportsPage';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { AdminUserDetailPage } from './pages/admin/AdminUserDetailPage';
import { AdminChatsPage } from './pages/admin/AdminChatsPage';
import { AdminChatDetailPage } from './pages/admin/AdminChatDetailPage';
import { AdminUsagePage } from './pages/admin/AdminUsagePage';
import { AdminCachePage } from './pages/admin/AdminCachePage';
import { AdminAdminsPage } from './pages/admin/AdminAdminsPage';
import { AdminChatSettingsPage } from './pages/admin/AdminChatSettingsPage';
import { AdminToolsPage } from './pages/admin/AdminToolsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { UpdateBanner } from './components/UpdateBanner';
import { GlobalChatDrawer } from './components/ChatDrawer';
import { useRightDock } from './hooks/use-right-dock';

export function App(): JSX.Element {
    // Правые панели (чат, карточка) сдвигают страницу, а не накрывают её —
    // когда на экране есть место. См. use-right-dock.
    useRightDock();
    return (
        <PageErrorBoundary>
            <Routes>
                <Route path="/"                       element={<HomePage />} />
                <Route path="/r/:owner/:repo/print"   element={<PrintPage />} />
                <Route path="/r/:owner/:repo/compare" element={<ComparePage />} />
                <Route path="/r/:owner/:repo/plan"    element={<PlanPage />} />
                <Route path="/r/:owner/:repo/reports" element={<ReportsPage />} />
                <Route path="/r/:owner/:repo"         element={<RepoPage />} />
                <Route path="/admin" element={<AdminLayout />}>
                    <Route index               element={<AdminOverviewPage />} />
                    <Route path="users"        element={<AdminUsersPage />} />
                    <Route path="users/:email" element={<AdminUserDetailPage />} />
                    <Route path="chats"        element={<AdminChatsPage />} />
                    <Route path="chats/:sessionId" element={<AdminChatDetailPage />} />
                    <Route path="usage"        element={<AdminUsagePage />} />
                    <Route path="tools"        element={<AdminToolsPage />} />
                    <Route path="cache"        element={<AdminCachePage />} />
                    <Route path="admins"       element={<AdminAdminsPage />} />
                    <Route path="chat-settings" element={<AdminChatSettingsPage />} />
                </Route>
                <Route path="*"                       element={<NotFoundPage />} />
            </Routes>
            <GlobalChatDrawer />
            <UpdateBanner />
        </PageErrorBoundary>
    );
}
